const getModalTriggers = () => {
    return document.querySelectorAll('.js_triggerModal')
}

export const getModal = (modalName) => {
    return document.querySelector(`.uiModal[data-modal="${modalName}"]`)
}

const toggleModal = (modal) => {
    modal.classList.toggle('uiModal--active')
}

const toggleScrollLock = () => {
    document.body.classList.toggle('noScroll')
}

const onTriggerClick = (trigger) => {
    const modalName = trigger.getAttribute('data-modal') !== '' ? trigger.getAttribute('data-modal') : 'default'
    triggerModal(modalName)
}


// Allows other scripts or methods to trigger a modal programatically
export const triggerModal = (modalName) => {
    const modal = getModal(modalName) 

    if (!modal) {
        console.error('Error: Modal not found with given name `' + modalName + '`')
    }

    toggleScrollLock()
    toggleModal(modal)
}

const init = () => {
    const triggers = getModalTriggers()
    triggers.forEach((t) => t.addEventListener('click', () => (
        onTriggerClick(t)
    )))
}

$(document).ready(init)
